// removed by extract-text-webpack-plugin
module.exports = {"appContent":"bo-k1E4GYrAefUYSxXnaf"};


//////////////////
// WEBPACK FOOTER
// ./shared/containers/App/paintersStyle.scss
// module id = 922
// module chunks = 0